import * as server from '../entries/pages/_layout.server.ts.js';

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/+layout.server.ts";
export const imports = ["_app/immutable/nodes/0.CaZ10OyR.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/DC8ybcx3.js","_app/immutable/chunks/DzATuTuW.js"];
export const stylesheets = ["_app/immutable/assets/0.7L3xNmTh.css"];
export const fonts = [];
